import React from "react"

export default function TermsOfUse() {
    return (
        <div className="contactPage">
        <div className="termsPage">
        <div className="aboutPageColumn">
            <div class="titleTerms">Terms and Conditions</div>
            <div className="sectionTerms">
            <div className="termsText">
            Welcome to Assa. By accessing or using this website, you agree to the following Terms and Conditions. These Terms apply to all current and future purchases and use of the Site. We may update the Terms at any time, and your continued use of the Site constitutes your acceptance of the revised Terms.
            </div>
            </div>
            <div className="sectionTerms">
            <div class="subtitle">1. Use of the Website</div>
            <div class="descriptionTerms">
            You agree to use the Site for lawful purposes and in a manner that does not violate any applicable laws, regulations, or the rights of others. We reserve the right to suspend or terminate your access at our sole discretion if you violate these terms.
             </div>
             <div className="sectionTerms">
            <div class="subtitle">2. Account Access and Conduct</div>
            <div class="descriptionTerms">
            Some features of the Site may require registration or payment. You are responsible for maintaining the security of your account and for any activity that occurs under it.
            </div>
              <div className="sectionTerms">
            <div class="subtitle">3. Chat and User Conduct</div>
            <div class="descriptionTerms">
            We expect all users to behave respectfully, especially in interactive areas such as chat. Disruptive or abusive behavior may result in removal or restriction from certain features, even if you have paid for access. 
            If you are not satisfied with another user's behavior, you can block them.
            </div>
            </div>
            </div>
            <div className="sectionTerms">
            <div class="subtitle">4. Payments and Refund Policy</div>
            <div class="descriptionTerms">
            All payments made through this website are final. We do not offer refunds or returns. By completing a purchase, you agree to this no-refund policy.
            </div>
            </div>
            <div className="sectionTerms">
            <div class="subtitle">5. Service Availability and Changes</div>
            <div class="descriptionTerms">
            We aim to provide continuous access to the Site, but we do not guarantee uninterrupted service. Features, functionality, or content may be updated, modified, or removed at any time without notice.
            </div>
            </div>
            <div className="sectionTerms">
            <div class="subtitle">6. Content and Ownership</div>
            <div class="descriptionTerms">
            All content on the Site — including text, graphics, layout, software, and interactive elements — is the property of Assa. You may not copy, reuse, reproduce, or distribute content without permission.
            </div>
            </div>
            <div className="sectionTerms">
            <div class="subtitle">7. Disclaimer</div>
            <div class="descriptionTerms">
            We aim to provide a functional and reliable service, but we cannot guarantee that the Site will always operate without issues. We are not responsible for any errors, interruptions, or losses that may result from using the Site.
            </div>
            </div>
            <div className="sectionTerms">
            <div class="subtitle">8. Limitation of Liability</div>
            <div class="descriptionTerms">
            You use the Site at your own discretion. To the fullest extent permitted by law, we are not liable for any indirect, incidental, or consequential damages related to your use of the Site.
            </div>
            </div>
            <div className="sectionTerms">
            <div class="subtitle">9. Cookies and Privacy</div>
            <div class="descriptionTerms">
            We use only essential cookies — for example, to support login and secure access. We do not use cookies for tracking or advertising.
            </div>
            </div>
             <div className="sectionTerms">
            <div class="subtitle">10. Prohibited Uses</div>
            <div class="descriptionTerms">
            You may not use the Site to violate any law or third-party rights; harass, threaten, impersonate, or abuse others; upload or distribute viruses or malicious code; interfere with the Site’s functionality or security; or engage in spamming, scraping, or unauthorized access.
            </div>
            </div>
             <div className="sectionTerms">
            <div class="subtitle">11. Indemnification</div>
            <div class="descriptionTerms">
            You agree to indemnify and hold harmless Assa from any claims, damages, or liabilities arising out of your use of the Site or your violation of these Terms.
              </div>
              </div>
            <div className="sectionTerms">
            <div class="subtitle">12. Contact</div>
            <div class="descriptionTerms">
            If you have any questions about these Terms, please refer to the contact information listed on our Contact Page.
            </div>
            </div>

            </div>
            </div>

        </div>
    </div>
    )
}